import React from "react";
import {
  Box,
  Container,
  Typography,
  Stack,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Button,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import SecurityIcon from "@mui/icons-material/Security";
import FingerprintIcon from "@mui/icons-material/Fingerprint";

export default function Security() {
  return (
    <Box component="main" sx={{ py: 8 }}>
      <Container maxWidth="md">
        <Stack spacing={3}>
          <Typography variant="h4" fontWeight={800}>
            Security — FentrixBank
          </Typography>

          <Typography>
            Security is a core pillar of our platform. We combine technical safeguards,
            operational controls, and continuous monitoring to protect your funds and
            personal information.
          </Typography>

          <Divider />

          <Typography variant="h6" fontWeight={700}>
            Our Security Principles
          </Typography>

          <List>
            <ListItem>
              <ListItemIcon>
                <LockIcon />
              </ListItemIcon>
              <ListItemText
                primary="Encryption & Transport"
                secondary="All data in transit is protected using TLS; sensitive data at rest is encrypted with robust algorithms (AES-256)."
              />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <SecurityIcon />
              </ListItemIcon>
              <ListItemText
                primary="Infrastructure & Hardening"
                secondary="Cloud infrastructure hardened with least-privilege, network segmentation, and regular patching."
              />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <FingerprintIcon />
              </ListItemIcon>
              <ListItemText
                primary="Authentication & Access Controls"
                secondary="Strong password rules, optional MFA (TOTP/Push) and device fingerprinting for risk-based authentication."
              />
            </ListItem>
          </List>

          <Divider />

          <Typography variant="h6" fontWeight={700}>
            Incident Response & Audits
          </Typography>

          <Typography>
            We maintain an incident response program, regular penetration testing by
            third parties, and internal security audits. Customers will be notified in
            line with regulatory requirements in the unlikely event of a breach.
          </Typography>

          <Divider />

          <Typography variant="h6" fontWeight={700}>
            How You Can Improve Account Security
          </Typography>

          <List>
            <ListItem>
              <ListItemText primary="Use a strong, unique password and enable MFA." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Do not share your credentials or verification codes." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Report suspicious emails or transactions immediately." />
            </ListItem>
          </List>

          <Box>
            <Typography variant="body2" color="text.secondary">
              If you suspect compromised access, contact Support immediately.
            </Typography>

            <Button
              variant="contained"
              sx={{ mt: 2 }}
              href="/contact"
              size="small"
            >
              Contact Support
            </Button>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}